import styled from 'styled-components';

export const ScenarioPageContent = styled.div`
  padding: 16px;
  padding-bottom: 80px; /* Space for fixed footer */
`;

export const SectionLabel = styled.a`
  color: #0066cc;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  display: block;
  margin-bottom: 8px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;
